export  const resources = {
    // APPLICATION_URL:  `http://103.248.210.12:8888/saispurthi-website-backend/api/v1/`,
    // AUTHORIZE_URL:  `http://103.248.210.12:8888/saispurthi-website-backend/api/auth/`,

   APPLICATION_URL:  `http://103.165.95.211:8080/saispurthi-website-backend/api/v1/`,
   AUTHORIZE_URL:  `http://103.165.95.211:8080/saispurthi-website-backend/api/auth/`,
}